import { render, staticRenderFns } from "./TeacherQuickView.vue?vue&type=template&id=96b25ea2&scoped=true"
import script from "./TeacherQuickView.vue?vue&type=script&lang=js"
export * from "./TeacherQuickView.vue?vue&type=script&lang=js"
import style0 from "./TeacherQuickView.vue?vue&type=style&index=0&id=96b25ea2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b25ea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96b25ea2')) {
      api.createRecord('96b25ea2', component.options)
    } else {
      api.reload('96b25ea2', component.options)
    }
    module.hot.accept("./TeacherQuickView.vue?vue&type=template&id=96b25ea2&scoped=true", function () {
      api.rerender('96b25ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/TeacherQuickView.vue"
export default component.exports